"use client"

import { FlipVertical2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FlipVertical2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FlipVertical2Icon = component(Icon)({ as: FlipVertical2 })
